import { CockpitCommunication } from '../../interfaces/cockpit-communication';

export const COCKPIT_TAG = 'cockpit';

export interface CockpitState {
  communications: CockpitCommunication[];
}
